module.exports = __webpack_public_path__ + "static/img/7.1347932.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/eng/7.png
// module id = myqN
// module chunks = 0